import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
// import { objAny } from "@/common/common-interface";
import piDatePicke from "@/components/pi-date-picke/pi-date-picke.vue";
import piRevenueData from "./components/pi-revenue-data/pi-revenue-data.vue";
import piSettlementData from "./components/pi-settlement-data/pi-settlement-data.vue";
import piOrderData from "./components/pi-order-data/pi-order-data.vue";
import { echartsJS } from "@/common/add-js";
// import i18n from "@/config/i18n";
let PiOperData = class PiOperData extends Vue {
    constructor() {
        super(...arguments);
        this.isEchart = false;
    }
    /**
     * 加载echarts
     */
    async echartInit() {
        await echartsJS();
        this.isEchart = true;
    }
    mounted() {
        this.echartInit();
    }
};
PiOperData = __decorate([
    Component({
        components: {
            "pi-date-picke": piDatePicke,
            "pi-revenue-data": piRevenueData,
            "pi-settlement-data": piSettlementData,
            "pi-order-data": piOrderData,
        },
    })
], PiOperData);
export default PiOperData;
